(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-story"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.sugar-free-video-wrapper').forEach(function (wrapper) {
    var video = wrapper.querySelector('video');
    if (!video) return;

    var playPauseBtn = wrapper.querySelector('.js-play-pause');
    var muteBtn = wrapper.querySelector('.js-mute-toggle');
    var iconPlay = playPauseBtn.querySelector('.icon-play');
    var iconPause = playPauseBtn.querySelector('.icon-pause');
    var iconMuted = muteBtn.querySelector('.icon-muted');
    var iconUnmuted = muteBtn.querySelector('.icon-unmuted');

    function syncPlayIcon() {
      if (video.paused) {
        iconPlay.style.display = '';
        iconPause.style.display = 'none';

        playPauseBtn.classList.add('is-paused');
        playPauseBtn.classList.remove('is-playing');
      } else {
        iconPlay.style.display = 'none';
        iconPause.style.display = '';

        playPauseBtn.classList.add('is-playing');
        playPauseBtn.classList.remove('is-paused');
      }
    }

    function syncMuteIcon() {
      if (video.muted) {
        iconMuted.style.display = '';
        iconUnmuted.style.display = 'none';

        muteBtn.classList.add('is-muted');
        muteBtn.classList.remove('is-unmuted');
      } else {
        iconMuted.style.display = 'none';
        iconUnmuted.style.display = '';

        muteBtn.classList.add('is-unmuted');
        muteBtn.classList.remove('is-muted');
      }
    }

    function togglePlayPause() {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    }

    wrapper.addEventListener('click', function (e) {
      if (e.target.closest('.video-control-btn')) return;
      togglePlayPause();
    });

    playPauseBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      togglePlayPause();
    });

    muteBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      video.muted = !video.muted;
      syncMuteIcon();
    });

    video.addEventListener('play', syncPlayIcon);
    video.addEventListener('pause', syncPlayIcon);

    syncPlayIcon();
    syncMuteIcon();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["built-in-action-video-demo"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.sugar-free-video-wrapper').forEach(function (wrapper) {
    var video = wrapper.querySelector('video');
    if (!video) return;

    var playPauseBtn = wrapper.querySelector('.js-play-pause');
    var muteBtn = wrapper.querySelector('.js-mute-toggle');
    var iconPlay = playPauseBtn.querySelector('.icon-play');
    var iconPause = playPauseBtn.querySelector('.icon-pause');
    var iconMuted = muteBtn.querySelector('.icon-muted');
    var iconUnmuted = muteBtn.querySelector('.icon-unmuted');

    function syncPlayIcon() {
      if (video.paused) {
        iconPlay.style.display = '';
        iconPause.style.display = 'none';

        playPauseBtn.classList.add('is-paused');
        playPauseBtn.classList.remove('is-playing');
      } else {
        iconPlay.style.display = 'none';
        iconPause.style.display = '';

        playPauseBtn.classList.add('is-playing');
        playPauseBtn.classList.remove('is-paused');
      }
    }

    function syncMuteIcon() {
      if (video.muted) {
        iconMuted.style.display = '';
        iconUnmuted.style.display = 'none';

        muteBtn.classList.add('is-muted');
        muteBtn.classList.remove('is-unmuted');
      } else {
        iconMuted.style.display = 'none';
        iconUnmuted.style.display = '';

        muteBtn.classList.add('is-unmuted');
        muteBtn.classList.remove('is-muted');
      }
    }

    function togglePlayPause() {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    }

    wrapper.addEventListener('click', function (e) {
      if (e.target.closest('.video-control-btn')) return;
      togglePlayPause();
    });

    playPauseBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      togglePlayPause();
    });

    muteBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      video.muted = !video.muted;
      syncMuteIcon();
    });

    video.addEventListener('play', syncPlayIcon);
    video.addEventListener('pause', syncPlayIcon);

    syncPlayIcon();
    syncMuteIcon();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadRelatedProductsIntoSection = function() {
  // Look for an element with class 'related-products'
  var relatedProductsSection = document.querySelector('.related-products');
  if (relatedProductsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", relatedProductsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      relatedProductsSection.innerHTML = container.querySelector('.related-products').innerHTML;
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// Fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadRelatedProductsIntoSection();
  }
});
// Fetch the products on page load
loadRelatedProductsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
